import React, { useMemo } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { news_content } from "../../content/news/newsContent";

const News: React.FC = () => {
  const [searchParams] = useSearchParams();
  const raw = searchParams.get("search")?.trim() ?? "";

  const filtered = useMemo(() => {
    if (!raw) return news_content.articles;

    const lower = raw.toLowerCase();

    return news_content.articles.filter((item) =>
      item.headline.toLowerCase().includes(lower)
    );
  }, [raw]);

  const getPreview = (text: string) => {
    const sentences = text.split(/(?<=[.!?])\s+/);
    const preview = sentences.slice(0, 2).join(" ");
    return sentences.length > 2 ? preview + "..." : preview;
  };

  return (
    <div className="mx-auto py-12 px-4 sm:px-6 lg:px-8 bg-[#FFFDF8]">

      {/* ===== HEADER ===== */}
      <div
        className="max-w-7xl mx-auto mb-8"
        style={{ paddingTop: "6rem" }}
      >
        <h1
          className="text-[48px] text-[#021847] mb-7"
          style={{ fontFamily: "Roboto Serif" }}
        >
          {news_content.header.title}
        </h1>
      </div>

      {/* ===== CONTENT ===== */}
      <div className="max-w-7xl mx-auto space-y-16">

        {/* ❌ NO RESULTS */}
        {filtered.length === 0 && raw ? (
          <div className="text-center py-20">
            <h2 className="text-2xl font-semibold text-[#021847]">
              No results found
            </h2>
            <p className="text-gray-500 mt-2">
              No results found for "<span className="font-medium">{raw}</span>"
            </p>
          </div>
        ) : (
          /* ✅ RESULTS */
          filtered.map((item) => (
            <article key={item.id}>
              <img
                src={item.images[0]}
                alt={item.headline}
                className="w-full md:h-[39rem] object-cover rounded-lg mb-6"
              />

              <div>
                <h2 className="text-xl font-semibold uppercase mb-2">
                  {item.headline}
                </h2>

                <div className="flex items-center gap-4 text-sm text-gray-600 mb-4">
                  <span>{item.comments} Comments</span>
                  <span>•</span>
                  <span>{item.likes} Likes</span>
                  <span>•</span>
                  <span>{item.shares} Shares</span>
                </div>

                <p className="text-[#6E6E6E] text-[20px] mb-6">
                  {getPreview(item.content)}
                </p>

                <Link to={`/news/${item.id}`}>
                  <button className="border px-6 py-2 rounded-md hover:bg-[#021847] hover:text-white transition">
                    READ MORE
                  </button>
                </Link>
              </div>
            </article>
          ))
        )}

      </div>
    </div>
  );
};

export default News;